import {Component} from '@angular/core';
import {fadeInOut} from "../../animations/fade";
import {LoaderService} from "../../services/loader.service";

@Component({
    selector: 'app-loader-widget',
    imports: [],
    templateUrl: './loader-widget.component.html',
    styleUrl: './loader-widget.component.scss',
    animations: [fadeInOut]
})
export class LoaderWidgetComponent {

  constructor(public $loader: LoaderService) {
    //
  }
}
